module.exports = __webpack_public_path__ + "img/fb.888c2009.svg";